import React from "react";
import { Button, Grid } from "@mui/material";

const renderActions = (item, actions) => (
  <Grid container spacing={1}>
    {actions.map((action, index) => (
      <Grid item key={index}>
        <Button
          variant={action.variant}
          color={action.color}
          sx={{
            ...action.sx,
            "&:hover": {
              ...action.hoverSx,
            },
          }}
          onClick={action.onclick}
          {...action.props}
        >
          {action.label}
        </Button>
      </Grid>
    ))}
  </Grid>
);

export default renderActions;
